module.exports = __webpack_public_path__ + "static/media/batch-default.5016a93d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/batch-default.svg
// module id = 422
// module chunks = 0